<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <circle cx="20" cy="20" r="20" fill="#10172C" fill-opacity="0.6" />
        <path d="M16 13.5L27 20L16 26.5V13.5Z" fill="white" />
    </svg>
</template>
